module.exports = __webpack_public_path__ + "static/media/biometric attendance icon.fd3fda01.svg";